import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import PhoneInput from '../shared/PhoneInput';
import MoneyInput from '../shared/MoneyInput';
import NumberInput from '../shared/NumberInput';

// `missing` outlines the input in amber: the last calc was refused for lack of it.
export function NumField({ label, value, onChange, step = '1', money = false, missing = false, min, max }) {
  const handle = (n) => onChange({ target: { value: n == null ? '' : String(n) } });
  const className = missing ? 'mt-1 border-amber-400 ring-1 ring-amber-300' : 'mt-1';
  const testId = missing ? 'missing-input' : undefined;
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      {money
        ? <MoneyInput value={value} onChange={handle} className={className} data-testid={testId} />
        : <NumberInput value={value} onChange={handle} min={min} max={max} className={className} data-testid={testId} />}
    </div>
  );
}

export function Field({ label, value, onChange, placeholder, testId, kind }) {
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      {kind === 'phone'
        ? <PhoneInput value={value} onChange={onChange} className="mt-1 text-[13px] h-9" data-testid={testId} />
        : <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1 text-[13px] h-9" data-testid={testId} />}
    </div>
  );
}
